export enum SaleTypeEnum {
    All = -1,
    RetailSales = 1,
    DirectSales = 2,
}
